import type { ComponentProps } from 'react';
import { memo } from 'react';

import ClownFaceIcon from '@/assets/icons/clown-face.svg?react';
import ShieldIcon from '@/assets/icons/shield.svg?react';
import SmilingFaceWithHaloIcon from '@/assets/icons/smiling-face-with-halo.svg?react';
import { cn } from '@/shared/utils/cn';

export interface ProfileNonToxicGuidelinesProps extends ComponentProps<'div'> {}

const GUIDELINES = [
  {
    icon: SmilingFaceWithHaloIcon,
    text: 'Respect your duos',
  },
  {
    icon: ClownFaceIcon,
    text: 'Report toxicity',
  },
  {
    icon: ShieldIcon,
    text: 'Duo with verified players',
  },
] as const;

export const ProfileNonToxicGuidelines = memo(
  function ProfileNonToxicGuidelines({
    className,
    ...rest
  }: ProfileNonToxicGuidelinesProps) {
    return (
      <div
        className={cn(
          'bg-purple-brand-950 border-purple-brand-400 flex flex-col gap-4 rounded-xl border-2 p-4',
          className,
        )}
        {...rest}
      >
        <div className="flex w-full">
          <h3 className="text-cold-200 text-base leading-none font-bold">
            How to keep safe:
          </h3>
        </div>
        <div className="flex flex-col gap-2">
          {GUIDELINES.map(guideline => {
            const Icon = guideline.icon;
            return (
              <div key={guideline.text} className="flex items-center gap-2">
                <div className="flex size-6 shrink-0 items-center justify-center">
                  <Icon className="size-6" />
                </div>
                <p className="text-cold-400 text-sm leading-5 font-medium">
                  {guideline.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    );
  },
);
